import React, { useState } from "react";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Header from "../../components/headers/MainHeader";
import Footer from "../../components/footers/MainFooterWithLinks";
import Shop from "./componets/DashedBorderSixFeatures";
import Cards from './componets/DashedBorderSixFeatures';
import styled, { css } from 'styled-components';
import tw from "twin.macro";
import SliderCard from "../../components/cards/ThreeColSlider.js";
import  DesignIllustration from "../../images/Без имени-2.png"
import {useTranslation} from "react-i18next";
// Стили для контейнера кнопок
const ButtonContainer = styled.div`
        ${tw`flex flex-wrap items-center justify-center gap-4`}
        ${tw`p-4 sm:px-4 md:px-8 lg:px-12 xl:px-16`}
    `;

// Базовые стили для кнопок
const BaseButtonStyles = css`
        ${tw`px-6 py-2 font-semibold rounded-lg shadow-md bg-white text-lg text-gray-600`}
        ${tw`h-12 w-full sm:w-auto`}
        ${tw`m-2`}
        border: 2px solid #0ABD19;
    
        &:hover {
            ${tw`text-black bg-green-200`}
        }
    
        &:focus {
            ${tw`text-black bg-green-200`}
        }
    `;

// Стили для первичной кнопки
const PrimaryButton = styled.button`
        ${BaseButtonStyles}
        ${({ selected }) => selected && css`
            ${tw`bg-green-200 border-green-700 text-black`}
        `}
    `;

// Стили для вторичной кнопки
const SecondaryButton = styled.button`
        ${BaseButtonStyles}
    `;

// Описание секции
const SectionDescription = styled.p`
        ${tw`mt-8 text-xl text-gray-700`}
    `;

export default function App() {
    const [selectedCountry, setSelectedCountry] = useState("США");
    const [selectedCategory, setSelectedCategory] = useState("Детский мир");
    const { t } = useTranslation();
    return (
        <AnimationRevealPage>
            <Header
                heading={t("stores.headerTitle")}
                paragraph={t("stores.headerDescription")}
                imageSrc={DesignIllustration}
                roundedHeaderButton={false}
            />
            {/*<ButtonContainer>*/}
            {/*    <PrimaryButton onClick={() => setSelectedCountry('США')} selected={selectedCountry === 'США'}>США</PrimaryButton>*/}
            {/*    /!*<PrimaryButton onClick={() => setSelectedCountry('Турция')} selected={selectedCountry === 'Турция'}>Турция</PrimaryButton>*!/*/}
            {/*</ButtonContainer>*/}
            <ButtonContainer>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.kids"))} selected={selectedCategory === t("stores.categories.kids")}>
                    {t("stores.categories.kids")}
                </SecondaryButton>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.health"))} selected={selectedCategory === t("stores.categories.health")}>
                    {t("stores.categories.health")}
                </SecondaryButton>
                {selectedCountry !== "Турция" && (
                    <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.pets"))} selected={selectedCategory === t("stores.categories.pets")}>
                        {t("stores.categories.pets")}
                    </SecondaryButton>
                )}
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.beauty"))} selected={selectedCategory === t("stores.categories.beauty")}>
                    {t("stores.categories.beauty")}
                </SecondaryButton>
                {selectedCountry !== "Турция" && (
                    <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.crypto"))} selected={selectedCategory === t("stores.categories.crypto")}>
                        {t("stores.categories.crypto")}
                    </SecondaryButton>
                )}
            </ButtonContainer>

            <ButtonContainer>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.marketplaces"))} selected={selectedCategory === t("stores.categories.marketplaces")}>
                    {t("stores.categories.marketplaces")}
                </SecondaryButton>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.fashion"))} selected={selectedCategory === t("stores.categories.fashion")}>
                    {t("stores.categories.fashion")}
                </SecondaryButton>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.hobby"))} selected={selectedCategory === t("stores.categories.hobby")}>
                    {t("stores.categories.hobby")}
                </SecondaryButton>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.electronics"))} selected={selectedCategory === t("stores.categories.electronics")}>
                    {t("stores.categories.electronics")}
                </SecondaryButton>
                <SecondaryButton onClick={() => setSelectedCategory(t("stores.categories.auto"))} selected={selectedCategory === t("stores.categories.auto")}>
                    {t("stores.categories.auto")}
                </SecondaryButton>
            </ButtonContainer>
            <Shop/>
            <Cards selectedCountry={selectedCountry} selectedCategory={selectedCategory}/>
            {/*<SliderCard />*/}
            <Footer />
        </AnimationRevealPage>
    );
}
